import { useMutation, useQueryClient } from "@tanstack/react-query";

import { updateCreditAllotmentAcknowledgements } from "services";

import { GET_CARBON_PROGRAM_OUTCOMES, UPDATE_FARM_CREDIT_ALLOTMENTS } from "consts";

export const useAddAllotmentAcknowledgements = ({ farmId }: { farmId: string }) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [UPDATE_FARM_CREDIT_ALLOTMENTS, farmId],
    mutationFn: updateCreditAllotmentAcknowledgements,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_CARBON_PROGRAM_OUTCOMES] });
    },
  });
};
